export function coursePackagesTableHead () {
	return [
		{
			text	: '№',
			align	: 'start',
			sortable: false,
			value	: 'index'
		},
		{
			text	: 'Name',
			value	: 'name'
		},
		{
			text	: 'Students',
			value	: 'students'
		},
		{
			text	: 'Access end',
			value	: 'access_expires_at',
			sortable: false
		},
		{
			sortable: false,
			text	: 'Actions',
			value	: 'actions'
		}
	]
}
